<script>
  import { showingTutorial } from "#src/stores/ui.js";
  import XIcon from "@local/assets/icons/x.svg";
  import PageScale from "./PageScale.svelte";
  import PageScale2 from "./PageScale2.svelte";
  import Tagging from "./Tagging.svelte";
  import Tagging2 from "./Tagging2.svelte";
  import Analyze from "./Analyze.svelte";
  import Edit from "./Edit.svelte";
  import Download from "./Download.svelte";
  import { profile } from "#src/stores/auth.js";

  const steps = [PageScale, PageScale2, Tagging, Tagging2, Analyze, Edit, Download];

  let currentStep = 0;

  function nextStep() {
    if (currentStep < steps.length - 1) {
      currentStep += 1;
    }
  }

  function prevStep() {
    if (currentStep > 0) {
      currentStep -= 1;
    }
  }

  function dismiss() {
    $showingTutorial = false;
    profile.dismissTutorial();
  }

  $: step = steps[currentStep];
</script>

<div class="px-4 pb-12 absolute bottom-0 left-0 z-50 pointer-events-none text-xs">
  <div
    class="bg-white rounded border-2 border-blue-500 shadow-lg shadow-blue-500/50 pointer-events-auto w-64">
    <div class="p-2 flex items-center border-b">
      <div class="grow">Tutorial</div>
      <button on:click={() => ($showingTutorial = false)} class="rounded p-1 hover:bg-gray-200">
        <XIcon />
      </button>
    </div>
    <div class="p-4">
      <svelte:component this={step} />
    </div>
    <div class="flex justify-between items-center p-3">
      <div class="flex gap-2">
        <button class="btn-text" on:click={prevStep} disabled={currentStep === 0}> Previous </button>
        <div>{currentStep + 1} of {steps.length}</div>
        <button class="btn-text" on:click={nextStep} disabled={currentStep === steps.length - 1}>
          Next
        </button>
      </div>
      {#if !$profile?.has_seen_tutorial}
        <button class="btn-text" on:click={dismiss}>Dismiss</button>
      {/if}
    </div>
  </div>
</div>
